import {
  type TDealer,
  type TDealerApi,
  type TDealerDetailedApi,
  type TDealerDto,
  type TDealerFilters
} from '@/components/AdminPanel/DealersPoints/types/dealers.types';
import { type StrictOmit } from '@/types/app';

import { ApiConnector } from '../api.connector';

class DealersApi extends ApiConnector {
  public getAdminAllDealers(body: TDealerFilters): Promise<{
    total: number;
    dealers: TDealerApi[];
  }> {
    return this.call({
      path: 'admin/dealers/getDealers',
      method: 'post',
      body,
      cancelable: true
    });
  }

  public getAdminDealerByParam(param: string | number): Promise<TDealer[]> {
    return this.call({ path: `admin/dealers/${param}/findByParam` });
  }

  public createAdminDealer(body: StrictOmit<TDealerDto, 'uuid'>) {
    return this.call({ path: 'admin/dealers', method: 'post', body });
  }

  public updateAdminDealer(body: TDealerDto) {
    return this.call({
      path: `admin/dealers/${body.uuid}`,
      method: 'patch',
      body
    });
  }

  public getAdminById(uuid: string): Promise<TDealerDetailedApi> {
    return this.call({ path: `admin/dealers/${uuid}`, cancelable: true });
  }
}

export const dealersApi = new DealersApi();
